import dynamic from "next/dynamic";
import { Placeholder } from "./support/Placeholder";

export const TokenExchangeCallbackWidget = dynamic(
  () =>
    import("./InternalLoginCallbackWidget").then(
      (module) => module.InternalLoginCallbackWidget
    ),
  {
    ssr: false,
    loading: () => {
      return <Placeholder />;
    },
  }
);
